declare var PriceSpider;

import * as productActions from "../../products/product.actions";

export function resizeImg(img, thumbnailW, thumbnailH, locale) {
  if (!img.naturalWidth || !img.naturalHeight) return;

  //add padding of 10px around image
  let padding = 0;
  let origThumbnailW = thumbnailW;
  let origThumbnailH = thumbnailH;
  thumbnailW -= padding;
  thumbnailH -= padding;
  let imgContainer = img.parentNode;
  let scale = Math.min(
    thumbnailW / img.naturalWidth,
    thumbnailH / img.naturalHeight
  );
  let scaledW = img.naturalWidth * scale;
  let scaledH = img.naturalHeight * scale;

  /*	img.style.width = scaledW + "px";
  img.style.height = scaledH + "px";*/
  /*	imgContainer.style.paddingTop = Math.round((origThumbnailH - scaledH)/2) + "px";
  imgContainer.style.paddingLeft = Math.round((origThumbnailW - scaledW)/2) + "px";*/
  if (locale !== "en-us") {
    imgContainer.style.background = "#fff";
  } else {
    imgContainer.style.background = "transparent";
  }
  /*imgContainer.style.background = "#fff";*/
  imgContainer.style.visibility = "visible";
  imgContainer.style.overflow = "hidden";
}

export function showImgError(img) {
  setTimeout(() => {
    img.parentNode.style.visibility = "visible";
  }, 2000);
}

export function getBuyButtonText(locale): string {
  return "buy_now";
  /*if (locale === 'en-us') {
    return "BUY NOW";
  } else if (locale === 'en-gb') {
    return "PRE-ORDER";
  }*/
}

export function changeDRId(digitialRiverID) {
  $(".js-product-item").removeData();
  return digitialRiverID;
}

export function showOverlay(productDetail, locale, store, hatchOverlayDisplay) {
  if (locale === "en-us") {
    showPriceSpiderOverlay(productDetail.sku);
  } else {
    showPriceSpiderOverlay(productDetail.sku);
  } /*else {
		hatchOverlayDisplay && hatchOverlayDisplay.emit({hatchOverlayDisplay: true, productDetail: productDetail, winPageYOffset: window.pageYOffset});
		store.dispatch(new productActions.LoadRetailInfo(productDetail.productUPC));
		document.body.style.overflow = 'hidden';
		stopBodyScrolling(true);
	}*/
}

export function stopBodyScrolling(bool) {
  if (bool === true) {
    (<any>document).addEventListener("touchmove", freezeVp, { passive: false });
    $("html").addClass("freeze-html");
  } else {
    (<any>document).removeEventListener("touchmove", freezeVp, {
      passive: false,
    });
    $("html").removeClass("freeze-html");
  }
  /*if (bool === true) {
       document.body.addEventListener("touchmove", freezeVp, false);
   } else {
       document.body.removeEventListener("touchmove", freezeVp, false);
   }*/
}

function freezeVp(e) {
  //e.preventDefault();
  e.stopPropagation();
}

function showPriceSpiderOverlay(upc) {
  let psDivPar = document.getElementById("psPar");
  psDivPar.innerHTML = "";
  let psD = document.createElement("DIV");
  psD.setAttribute("class", "ps-widget");
  psD.setAttribute("ps-sku", upc);
  psDivPar.appendChild(psD);

  PriceSpider.rebind(function () {
    psD.click();
  });
}

function removeNoScrollClass(winPageYOffset) {
  //$(document.body).removeClass("noscroll");
  stopBodyScrolling(false);
  window.scroll(0, winPageYOffset);
  //document.body.style.overflow = '';
}

export function getPriceIntegerDot(price): string {
  let newPrice = Math.floor(price).toLocaleString();
  return newPrice + ".";
  //return price
}

export function getPriceDecimal(price): string {

  // return price.substr(-2);
  return price ? price.toFixed(2).toString().split(".")[1] : "00";
}

export function extractDRPriceIntegerDot(priceDiv, drSpinnerCont) {
  let str = priceDiv.innerHTML;
  if (!str) {
    return;
  }
  drSpinnerCont && (drSpinnerCont.style.backgroundImage = "none");
  if (str.indexOf("<sup>") === -1) {
    return str;
  }
  return str.substring(0, str.indexOf("<sup>")).replace(/ /g, "");
}

export function extractDRPriceDecimal(priceDiv) {
  let str = priceDiv.innerHTML;
  if (!str || str.indexOf("<sup>") === -1) {
    return;
  }
  return str
    .substring(str.indexOf("<sup>") + 5, str.indexOf("</sup>"))
    .replace(/ /g, "");
}

export function productName(productDetail) {
  var locale = window.location.pathname.split("/")[1];
  var buy_now;
  switch (locale) {
    case "en-us":
      buy_now = "Buy Now";
      break;
    /*case "en-ca": buy_now = "BUY NOW"; break;
  case "en-au": buy_now = "BUY NOW"; break;
  case "en-gb": buy_now = "BUY NOW"; break;
    case "ru-ru": buy_now = "КУПИТЬ"; break;
    case "fr-fr": buy_now = "Acheter maintenant"; break;
    case "fr-ca": buy_now = "Acheter maintenant"; break;
    case "de-de": buy_now = "Jetzt Kaufen"; break;*/
    case "ru-ru":
      buy_now = "Купить";
      break;
    default:
      buy_now = "Buy Now";
      break;
  }

  setTimeout(function () {
    var $title_element = $(".hatch-76b900").parent().siblings().first();
    $title_element.find("div").html(productDetail.productVariationName).css({
      color: "#595959",
      "max-width": "800px",
      "font-weight": "bold",
      "font-size": "24px",
    });
    $title_element
      .css({ "border-bottom": "1px solid #e1e1e1", position: "relative" })
      .find("svg")
      .css("stroke", "#000");
    $(".hatch-76b900")
      .find("svg")
      .replaceWith(
        '<div  class="buy-link" style="line-height: 24px;">' +
        buy_now +
        "</div>"
      );
    $title_element.parent().css("padding-top", "24px");
  }, 500);
}

/*export function listenForNotifyMe() {
  const startAttachingNotifyMeListenerStart = Date.now();
  let notifyMeListenerAttached = false;
  function addNotifyMeListener() {
    // .dr-modal-form-for-notify-me is outside of our Angular app
    // $('.dr-modal-form-for-notify-me .btn').click(
    $('.dr-modal-form-for-notify-me').click(
        function() {
        $('body').addClass('notify-me-open');

        setTimeout(function() {
          $('#cboxOverlay, #cboxClose').click(function() {
            $('body').removeClass('notify-me-open');
          });
        }, 0) // 300 worked

      }
    );
  }
  function tryDrModalForm() {
    if ($('.dr-modal-form-for-notify-me').length < 1) {
      // window.requestAnimationFrame(tryDrModalForm);
      // stack overflow
      // tryDrModalForm();
      return false;
    } else {
      let drModalReadyTime = Date.now() - startAttachingNotifyMeListenerStart;
      // addNotifyMeListener();
      setTimeout(addNotifyMeListener, 0);
      notifyMeListenerAttached = true;
      return true;
     }
  };
  for (let i = 0; i < 1000; i += 1) {
      (function(i) {
        setTimeout(function() {
        if (!notifyMeListenerAttached) {
          tryDrModalForm();
        }
      }, i * 1);
    })(i);
  }

}*/

export function reBindCart(callback) {
  $(".js-product-item").removeData();
  //window['appSetupHelpers'].appSetup();
  callback();
}
